// Ultra-light debounce
export const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

// Ultra-light throttle
export const throttle = (func, limit) => {
  let inThrottle;
  return (...args) => {
    if (!inThrottle) {
      func(...args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
};

// Lightweight memoization
export const memoize = (fn) => {
  const cache = new Map();
  return (...args) => {
    const key = JSON.stringify(args);
    if (cache.has(key)) return cache.get(key);
    const result = fn(...args);
    if (cache.size > 100) cache.clear(); // Prevent memory leaks
    cache.set(key, result);
    return result;
  };
};

// Preload critical resources
export const preloadResource = (href, as) => {
  const link = document.createElement('link');
  link.rel = 'preload';
  link.href = href;
  link.as = as;
  document.head.appendChild(link);
};

// Web Vitals reporting (lightweight)
export const reportPerformance = () => {
  if (typeof window !== 'undefined' && 'performance' in window) {
    setTimeout(() => {
      const nav = performance.getEntriesByType('navigation')[0];
      if (nav) {
        console.log('Load time:', nav.loadEventEnd - nav.fetchStart, 'ms');
      }
    }, 0);
  }
};
